import $ from "jquery";
import React, { Component } from "react";
import { Field, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { Row, Column } from "react-foundation";
import Loading from "components/Loading";
import Select from "react-select";

import { getDoorWERList } from "./../../selectors";

import InputError from "../../components/InputError";
import ThemeButton from "../../components/ThemeButton";
import bfrcLogo from "../../images/bfrc-logo.svg";
import werImage from "../../images/wer-end@2x.jpg";
import SeparatingLine from "../../components/SeparatingLine";
import FormHeader from "../../components/FormHeader";
import FormWrapper from "../FormWrapper";

const PrettifyEfficiency = ({ value }) => {
    let colors = {
        APlusPlus: "#BB0A7E",
        APlus: "#6C1F7D",
        A: "#0065B3",
        B: "#207E3F",
        C: "#73BE45"
    };

    return (
        <span className="efficiency-value">
            <span className="efficiency-value-letter" style={{ borderColor: colors[value] }}>
                {value.replace(/plus/i, "")}
            </span>
            <span className="efficiency-value-plus">
                {value.replace(/plus/i, "+").replace(/[^+]/, "")}
            </span>
        </span>
    );
};

const SelectEfficiency = props => {
    let { efficiencies, input } = props;

    if ($.isEmptyObject(efficiencies)) {
        return <Loading />;
    }

    var options = efficiencies.map(e => ({
        value: e.id,
        label: <PrettifyEfficiency value={e.name} />
    }));

    return (
        <div>
            <Row>
                <Column
                    small={12}
                    medium={10}
                    large={8}
                    centerOnSmall
                    className="efficiency-choice"
                >
                    {"I'm looking to achieve an Energy Rating of "}
                    <Select
                        className="efficiency-select"
                        onChange={val => input.onChange(val.value)}
                        options={options}
                        value={input.value}
                        clearable={false}
                        searchable={false}
                        placeholder=""
                    />
                </Column>
            </Row>
            <InputError metas={props.meta} />
        </div>
    );
};

class EfficiencyForm extends Component {
    render() {
        return (
            <form
                onSubmit={this.props.handleSubmit(this.props.onSubmit)}
                className="EfficiencyForm"
            >
                <FormHeader
                    title={"Energy Efficiency"}
                    subtitle={
                        "We can cater for either a high-end or more budget focussed glazing specification on our windows and doors."
                    }
                />

                <SeparatingLine />

                <FormWrapper>
                    <Field
                        name="DoorEfficiencyId"
                        component={SelectEfficiency}
                        efficiencies={this.props.efficiencies}
                    />

                    <Row>
                        <Column small={12} medium={10} large={8} centerOnSmall>
                            <Row>
                                <Column small={11} medium={10} className="wer-explanation">
                                    <p>
                                        <br />
                                        {
                                            "Choosing more energy efficient windows and doors will increase your initial costs but lower your ongoing heating bills. They can also increase your house’s resale value."
                                        }
                                        <br />
                                        <br />
                                        <img src={bfrcLogo} alt="BFRC" style={{ marginRight: 5, float: 'left' }} />
                                        <small>
                                            {
                                                "Your installation will be supplied with an Energy Performance Certificate that states the achieved WER (Window Energy Rating), as defined by the British Fenestration Ratings Council."
                                            }
                                        </small>
                                    </p>
                                </Column>
                                <Column small={12} className="wer-image">
                                    <div className="wer-expanding">
                                        <img src={werImage} alt="" />
                                    </div>
                                </Column>
                            </Row>
                        </Column>
                    </Row>
                </FormWrapper>

                <div className="button-panel">
                    <SeparatingLine />
                    <button className="button back" type="button" onClick={this.props.previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    let valueSelector = formValueSelector("DoorWizard");
    let doorStyleId = valueSelector(state, "DoorStyleId");

    return {
        efficiencies: getDoorWERList(state),
        doorStyleId
    };
};

export default connect(mapStateToProps, {})(EfficiencyForm);



// WEBPACK FOOTER //
// ./src/containers/DoorForm/EfficiencyForm.js